import React, {
  useState,
  useEffect,
  useMemo,
  useContext,
  forwardRef,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/actions/index";
import "./indeterminateCheckbox.css";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy, useFilters } from "react-table";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import Axios from "axios";
import styles from "./index.module.scss";
import BulkUpdateModal from "../../Utils/dialogs/BulkUpdateModal";
import Pagination from "../../Utils/Pagination";
import * as moment from "moment";
import NoRecord from "./Assets/noRecord.svg";
import ScaleLoader from "react-spinners/ScaleLoader";
import { AuthContext } from "../../services/AuthProvider";
import UrlLinks from "../../UrlLinks";
import JobFilter from "../../Utils/FilterComponents/JobFilter";
import CustomStatusDropdown from "./Functions/CustomStatusDropdown";
import ExportButton from "../../Utils/functions/ExportButton";
import ActionsDropdown from "../../Utils/functions/ActionsDropdown";
import OnboardingModal from "../../Utils/dialogs/OnboardingModal";
import FilterDrawer from "./components/FilterDrawer";
import filterIcon from "../ProjectConfig/filterIcon.svg";
import filterIconMarked from "../ProjectConfig/filterIconMarked.svg";
import DownloadDocuments from "./components/DownloadDoc";
import RemoveExtraSpaces from "../../Utils/functions/RemoveExtraSpaces";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, Grid, Checkbox, Drawer, Tooltip } from "@material-ui/core";
import { urlToPromise } from "../../Utils/CommonFunctions";
import { AppData } from "../../context/context";
import DeleteConfirmationModal from "../../Utils/dialogs/DeleteConfirmationModal";
import SearchBar from "../../Utils/functions/SearchBar";
import { trackEvent, FE_EVENTS } from '../../Utils/analytics';

const CustomToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#E9E9E9",
    color: "rgba(46, 46, 46, 1)",
    padding: "5px 10px",
    maxWidth: 237,
    fontSize: "14px",
    lineHeight: "170%",
    borderRadius: "6px",
    fontStyle: "normal",
    fontWeight: 400,
    "& .MuiTooltip-arrow": {
      color: "#E9E9E9",
    },
  },
}))(Tooltip);

const Styles = styled.div`
  padding: 1rem;
  .tableContainer {
    overflow-x: scroll;
    border: 1px solid #cfcfcf;
    border-radius: 5px;
    max-height: 74vh;
  }
  .tableContainer::-webkit-scrollbar {
    width: 0.75em;
  }

  .tableContainer::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .tableContainer::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
  table {
    border-spacing: 0;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      :last-child {
        border-left: 0;
      }
      background-color: #1c4980 !important;
      color: #ffffff;
    }
    th,
    td {
      padding: 5px 15px;
    }

    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #cfcfcf;
      border-right: 1px solid #cfcfcf;
      background-color: white;
      nth-last-child(2) {
        border-right: 0;
      }
      :last-child {
        border-right: 0;
      }

      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }

  .pagination {
    padding: 0.5rem;
  }
`;

const useStyles = makeStyles((theme) => ({}));

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <React.Fragment>
      <Checkbox ref={resolvedRef} {...rest} />
    </React.Fragment>
  );
});

const ExternalWorker = (props) => {
  /** accessing states from redux store **/

  const { users, tcsJobsDb } = useSelector((state) => state);
  const {
    loader,
    currentPage,
    perPage,
    totalRows,
    totalPages,
    isFilter,
    selectedAssignIds,
    selectedUserIds,
    openFilterDrawer,
    allRecord,
  } = users;
  const {
    multipleCity,
    multipleCenterName,
    multipleQualification,
    multipleRole,
    tableValue,
  } = tcsJobsDb;

  /** useDispatch is used to update states to redux store **/

  const dispatch = useDispatch();
  const {
    setLoader,
    setModalLoader,
    setCurrentPage,
    setPerPage,
    setTotalRows,
    setTotalPages,
    setIsFilter,
    setSelectedAssignIds,
    setSelectedUserIds,
    setOpenFilterDrawer,
    setTcsMultipleSelect,
    setAllRecord,
  } = bindActionCreators(actionCreators, dispatch);

  /** other states **/

  const classes = useStyles();
  const { showToast } = useContext(AuthContext);
  const { userAction } = useContext(AppData);
  const cancelTokens = useRef({
    mainListingData: null,
    applicationStatus: null,
    userNotification: null,
  });
  const cancelTokenSource = Axios.CancelToken.source();
  const [data, setData] = useState([]);
  const [actions, setActions] = useState(-1);
  const [allRecordLoading, setAllRecordLoading] = useState(false);
  const [searchByAuto, setSearchByAuto] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [filterUrl, setFilterUrl] = useState("");
  const [docListLoader, setDocListLoader] = useState(null);
  const [cityId, setCityId] = useState([]);
  const [tcsCenterName, setTcsCenterName] = useState([]);
  const [qualification, setQualification] = useState([]);
  const [role, setRole] = useState([]);
  const [searchError, setSearchError] = useState(false);
  const [toggleStatusUpdated, setToggleStatusUpdated] = useState(false);
  const [jobFilterOption, setJobFilterOption] = useState("active");
  const [jobList, setJobList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [openBulkUpdateModal, setOpenBulkUpdateModal] = useState(false);
  const [openMpaModal, setOpenMpaModal] = useState(false);
  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [openBlacklistMemberModal, setOpenBlacklistMemberModal] =
    useState(false);
  const [openBackedOutModal, setOpenBackedOutModal] = useState(false);
  const [columns, setColumns] = useState([]);
  const [viewCount, setViewCount] = useState(1);
  const [cityList, setCityList] = useState([]);
  const [tcsCenterList, setTcsCenterList] = useState([]);
  const [qualificationsList, setQualificationsList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [screeningLength, setScreeningLength] = useState(null);
  const [selectedOption, setSelectedOption] = useState({
    id: "active",
    name: "Active Jobs",
  });
  const [selectedStatusOption, setSelectedStatusOption] = useState({
    id: "-1",
    name: "All",
  });
  const [filters, setFilters] = useState({
    activityStatus: "",
    city: "",
    jobStatus: 1,
    qualification: "",
    role: "",
    searchBy: "",
    statusId: "",
    tcsCenterName: "",
  });

  const searchList = [
    {
      typeKey: 1,
      typeValue: "All",
    },
    {
      typeKey: 2,
      typeValue: "Screening",
    },
    {
      typeKey: 3,
      typeValue: "Profile",
    },
    {
      typeKey: 4,
      typeValue: "Form Data",
    },
  ];
  const jobFilterOptionList = [
    {
      id: "active",
      name: "Active",
    },
    {
      id: "inactive",
      name: "In-Active",
    },
  ];
  const actionList = [
    {
      value: "updateData",
      label: "Update Data",
    },
    {
      value: "bulkUpdate",
      label: "Bulk Update",
    },
    {
      value: "updateStatus",
      label: "Update Status",
    },
    {
      value: "blacklist",
      label: "Blacklist",
    },
    {
      value: "backedOut",
      label: "Backed Out",
    },
  ];

  const sortStatusOrder = [
    "13",
    "12",
    "1",
    "24",
    "25",
    "26",
    "27",
    "28",
    "36",
    "7",
    "9",
    "30",
    // "29",
    "32",
    "31",
    // "33",
    // "35",
  ];

  const allColumns = useMemo(() => {
    const baseColumns = [
      {
        Header: "Name",
        accessor: "firstName",
        Cell: (row) => {
          return (
            <div style={{ width: "200px" }}>
              {`${
                row.row.original.firstName &&
                row.row.original.firstName !== null
                  ? row.row.original.firstName
                  : ""
              } ${
                row.row.original.lastName && row.row.original.lastName !== null
                  ? row.row.original.lastName
                  : ""
              }`}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",
        Cell: (row) => {
          return (
            <div style={{ width: "143px" }}>
              {row.row.original.phoneNumber || "-"}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "TCS Resource ID",
        accessor: "tcsResourceId",
        Cell: (row) => {
          return (
            <div style={{ width: "155px" }}>
              {row.row.original.tcsResourceId || "-"}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Status",
        accessor: "applicationStatus",
        Cell: (row) => {
          return (
            <div style={{ width: "200px" }}>
              {row.row.original.applicationStatus
                ? statusList?.find(
                    (item) => item.id == row.row.original.applicationStatus
                  )?.name || "-"
                : "-"}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Job Name",
        accessor: "jobName",
        Cell: (row) => {
          return (
            <div style={{ width: "300px" }}>
              {row.row.original.jobName || "-"}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Status Updated On",
        accessor: "updatedOn",
        Cell: (row) => {
          return (
            <div>
              {row.row.original.updatedOn
                ? moment(row.row.original.updatedOn).format("DD/MM/YYYY")
                : "-"}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
    ];

    if (!!userAction.edit) {
      baseColumns.unshift({
        id: "selection",
        Header: ({ getToggleAllRowsSelectedProps }) => (
          <div>
            <IndeterminateCheckbox
              {...getToggleAllRowsSelectedProps()}
              className="overrideCheckbox"
              color="default"
              style={{ color: "#fff" }}
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div id="check1">
            <IndeterminateCheckbox
              {...row.getToggleRowSelectedProps()}
              style={{ display: "flex", justifyItems: "center" }}
            />
          </div>
        ),
      });
    }

    return baseColumns;
  }, [userAction.edit, statusList]);

  const screeningColumns = useMemo(() => {
    let list = [];
    let screeningLen = data.find((ele) => {
      return ele.screening.length > 0;
    });
    setScreeningLength(screeningLen);
    for (let i = 0; i < screeningLen?.screening?.length; i++) {
      let headerQues = screeningLen?.screening[i].ques.slice(0, 25);
      list.push({
        Header: (
          <CustomToolTip
            title={<div>{screeningLen?.screening[i].ques}</div>}
            arrow
          >
            <span>
              {headerQues}
              {screeningLen?.screening[i].ques.length > headerQues.length
                ? `.......?`
                : ""}
            </span>
          </CustomToolTip>
        ),
        accessor: `screening_${i}`,
        Cell: (row) => {
          return <div>{row.row.original.screening[i]?.ans}</div>;
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      });
    }
    const baseColumns = list;
    return baseColumns;
  }, [userAction.edit, tableValue, data]);

  const profileColumns = useMemo(() => {
    const baseColumns = [
      {
        Header: "Gender",
        accessor: "gender",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.gender}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Date of birth",
        accessor: "dateOfBirthNew",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.dateOfBirthNew
                ? moment(row.row.original.profile.dateOfBirthNew).format(
                    "DD/MM/YYYY"
                  )
                : ""}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "City",
        accessor: "city",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.city}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Profile Photo",
        accessor: "profilePhoto",
        Cell: (props) => (
          <DownloadDocuments {...props} uniqueId="profilePhoto" />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Assets",
        accessor: "assets",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.assets}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Languages",
        accessor: "languages",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.languages}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Pincodes",
        accessor: "pincodes",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.profile.pincodes}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
    ];

    return baseColumns;
  }, [userAction.edit, tableValue, data]);

  const formDataColumns = useMemo(() => {
    const baseColumns = [
      {
        Header: "Email Id",
        accessor: "emailId",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.emailId}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Role",
        accessor: "selectRole",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.selectRole}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Current city",
        accessor: "mentionYourCurrentCity",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.mentionYourCurrentCity}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Alternate Number",
        accessor: "altNumber",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.altNumber}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Father's Name",
        accessor: "fathersName",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.fathersName}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Mother's Name",
        accessor: "mothersName",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.mothersName}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Tenth Marksheet",
        accessor: "tenthMarksheet",
        Cell: (props) => (
          <DownloadDocuments {...props} uniqueId="tenthMarksheet" />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Twelfth Marksheet",
        accessor: "twelfthMarksheet",
        Cell: (props) => (
          <DownloadDocuments {...props} uniqueId="twelfthMarksheet" />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Ex-Serviceman Id",
        accessor: "exServicemanIdFromTheZilaSainikBoard",
        Cell: (props) => (
          <DownloadDocuments
            {...props}
            uniqueId="exServicemanIdFromTheZilaSainikBoard"
          />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Are you an ex-defence personnel?",
        accessor: "areYouAnExDefencePersonnel",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.areYouAnExDefencePersonnel}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Discharge book copy",
        accessor: "dischargeBookCopy",
        Cell: (props) => (
          <DownloadDocuments {...props} uniqueId="dischargeBookCopy" />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Degree type",
        accessor: "degreeType",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.degreeType}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Other degree",
        accessor: "otherDegree",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.otherDegree}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Graduation/Post-graduation marksheet",
        accessor: "uploadYourGraduationPostGraduationMarksheet",
        Cell: (props) => (
          <DownloadDocuments
            {...props}
            uniqueId="uploadYourGraduationPostGraduationMarksheet"
          />
        ),
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Current address",
        accessor: "provideYourCurrentAddress",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.provideYourCurrentAddress}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Nearest police station",
        accessor: "mentionYourNearestPoliceStation",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.mentionYourNearestPoliceStation}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Nearest IDs",
        accessor: "selectNearestIdz",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.selectNearestIdz}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Emergency contact number",
        accessor: "contactNumberOfParentsSpouseForEmergency",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {
                row.row.original.formData
                  ?.contactNumberOfParentsSpouseForEmergency
              }
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "QC",
        accessor: "qc",
        Cell: (row) => {
          return (
            <div style={{ width: "min-content" }}>
              {row.row.original.formData?.qc}
            </div>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
    ];

    return baseColumns;
  }, [userAction.edit, tableValue, data]);

  // Function to update the Table Data
  const updateMyData = (configTable, isViewMore) => {
    getExternalWorkerList(perPage, currentPage, configTable, isViewMore);
  };

  const resetFiltersWithoutSearch = () => {
    setIsFilter(false);
    const filterList = {
      activityStatus: "",
      city: "",
      jobStatus: filters.jobStatus,
      qualification: "",
      role: "",
      searchBy: filters.searchBy,
      statusId: filters.statusId,
      tcsCenterName: "",
    };

    setFilterUrl(
      `${filters.searchBy ? "&searchBy=" + filters.searchBy : ""}${
        filters.jobStatus ? "&jobStatus=" + filters.jobStatus : ""
      }${filters.statusId ? "&applicationStatus=" + filters.statusId : ""}`
    );
    setFilters(filterList);
    setCityId([]);
    setTcsCenterName([]);
    setQualification([]);
    setRole([]);
    setTcsMultipleSelect([], [], [], []);
    setCurrentPage(1);
    return filterList;
  };

  const createDocumentZip = (documents, okaygoId, name) => {
    var zip = new JSZip();
    var profilePhotoURL = documents;
    var photoName = "";

    const isLocal = window.location.hostname === "localhost";
    if (!isLocal) {
      profilePhotoURL = profilePhotoURL.replace(/^http:\/\//, "https://");
    }

    if (profilePhotoURL.includes(".jpg?")) {
      photoName = `${name.replaceAll(" ", "")}_Profile_Photo.jpg`;
    } else if (profilePhotoURL.includes(".png?")) {
      photoName = `${name.replaceAll(" ", "")}_Profile_Photo.png`;
    }

    zip.file(photoName, urlToPromise(profilePhotoURL), { binary: true });

    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, `${okaygoId}_${name}_Documents`);
      setDocListLoader(null);
    });
  };

  const getDocumentList = (type, userId, res) => {
    setDocListLoader(userId);
    let docUrl =
      type === "profilePhoto"
        ? res.profile.profilePhoto
        : type === "tenthMarksheet"
        ? res.formData.tenthMarksheet
        : type === "twelfthMarksheet"
        ? res.formData.twelfthMarksheet
        : type === "exServicemanIdFromTheZilaSainikBoard"
        ? res.formData.exServicemanIdFromTheZilaSainikBoard
        : type === "dischargeBookCopy"
        ? res.formData.dischargeBookCopy
        : res.formData.uploadYourGraduationPostGraduationMarksheet;

    createDocumentZip(docUrl, userId, res.firstName);
    setDocListLoader(null);
  };

  const handleSearch = () => {
    trackEvent(FE_EVENTS.TCS_SEARCH);
    setFilters({ ...filters, searchBy: searchBy });
    setSearchByAuto(searchBy);
  };

  const handleSearchClose = () => {
    setFilters({ ...filters, searchBy: "" });
    setSearchBy("");
    setFilterUrl("");
    setSearchByAuto("");
  };

  const updateFilterUrl = () => {
    let url = "";

    // Job Filters
    if (filters["jobId"]) {
      url = `${url}&jobId=${filters["jobId"]}`;
    }

    // Job Status Filters
    if (filters["jobStatus"] !== "") {
      url = `${url}&jobStatus=${filters["jobStatus"]}`;
    }

    // Application Status Filters
    if (filters["statusId"] !== "" && filters["statusId"] !== "-1") {
      url = `${url}&applicationStatus=${filters["statusId"]}`;
    }

    // Search By
    if (filters["searchBy"]) {
      url = `${url}&searchBy=${filters["searchBy"]}`;
    }

    // Activity Status url
    if (filters["activityStatus"]) {
      url = `${url}&applicationStatus=${filters["activityStatus"].id}`;
    }

    // City url
    if (filters["city"]) {
      url = `${url}&city=${filters["city"]}`;
    }

    // Qualification url
    if (filters["qualification"]) {
      url = `${url}&qualification=${filters["qualification"]}`;
    }

    // Role url
    if (filters["role"]) {
      url = `${url}&role=${filters["role"]}`;
    }

    // TCS Center Name url
    if (filters["tcsCenterName"]) {
      url = `${url}&centerName=${filters["tcsCenterName"]}`;
    }

    return url;
  };

  const ApplyFilters = () => {
    let url = updateFilterUrl();
    setFilterUrl(url);
    setFilters(filters);
    setCurrentPage(1);
  };

  //Function to create export data as per the main listing order
  const makeLeadExportData = (response) => {
    let extractedData = [];
    response?.map(async (el) => {
      let screeningData = {};
      await el.screening.forEach((sEl) => {
        screeningData[sEl.ques] = sEl.ans;
      });

      extractedData.push({
        Name:
          `${el.firstName && el.firstName !== null ? el.firstName : ""} ${
            el.lastName && el.lastName !== null ? el.lastName : ""
          }` || "",
        "Phone Number": el.phoneNumber || "",
        "TCS Resource Id": el.tcsResourceId || "",
        Status: el.applicationStatus
          ? statusList?.find((item) => item.id == el.applicationStatus)?.name ||
            ""
          : "",
        "Job Name": el.jobName,
        "Status updated on": el.updatedOn
          ? moment(el.updatedOn).format("DD/MM/YYYY")
          : "-",
        ...screeningData,
        Gender: el.profile.gender ? el.profile.gender : "",
        "Date of birth": el.profile?.dateOfBirthNew
          ? moment(el.profile.dateOfBirthNew).format("DD/MM/YYYY")
          : "",
        City: el.profile?.city || "",
        "Profile photo": el.profile?.profilePhoto || "",
        Assets: el.profile?.assets ? el.profile?.assets : "",
        Languages: el.profile?.languages || "",
        Pincodes: el.profile?.pincodes || "",
        "Aadhaar Number": el.otherInfo?.bankDetails?.aadharNumber || "",
        "Aadhaar Front": el.otherInfo?.bankDetails?.aadharFront || "",
        "Aadhaar Back": el.otherInfo?.bankDetails?.aadharBack || "",
        "PAN Number": el.otherInfo?.bankDetails?.panNumber || "",
        PAN: el.otherInfo?.bankDetails?.pan || "",
        "Permenant Address": el.otherInfo?.address?.perAddressLine1 || "",
        "Email ID": el.formData?.emailId || "",
        Role: el.formData?.selectRole || "",
        "Current city": el.formData?.mentionYourCurrentCity || "",
        "Alternate number": el.formData?.altNumber || "",
        "Father's name": el.formData?.fathersName || "",
        "Mother's name": el.formData?.mothersName || "",
        "Tenth marksheet": el.formData?.tenthMarksheet || "",
        "Twelfth marksheet": el.formData?.twelfthMarksheet || "",
        "Ex-Serviceman ID":
          el.formData?.exServicemanIdFromTheZilaSainikBoard || "",
        "Are you an ex-defence personnel":
          el.formData?.areYouAnExDefencePersonnel || "",
        "Discharge book copy": el.formData?.dischargeBookCopy || "",
        "Degree type": el.formData?.degreeType || "-",
        "Other degree": el.formData?.otherDegree || "",
        "Graduation/Post-graduation marksheet":
          el.formData?.uploadYourGraduationPostGraduationMarksheet || "",
        "Current address": el.formData?.provideYourCurrentAddress || "",
        "Nearest police station":
          el.formData?.mentionYourNearestPoliceStation || "-",
        "Nearest IDs": el.formData?.selectNearestIdz || "-",
        "Emergency contact number":
          el.formData?.contactNumberOfParentsSpouseForEmergency || "",
        QC: el.formData?.qc || "",
      });
      return true;
    });
    return extractedData;
  };

  const getDataType = (configTable, isViewMore, tableValue) => {
    if (configTable) {
      if (isViewMore) {
        switch (configTable) {
          case 2:
            return "&data=basic&data=screening";
          case 3:
            return "&data=basic&data=screening&data=profile";
          default:
            return "&data=basic&data=screening&data=profile&data=formData";
        }
      }

      setViewCount(1);
      switch (configTable) {
        case 1:
          return "&data=basic";
        case 2:
          return "&data=basic&data=screening";
        case 3:
          return "&data=basic&data=profile";
        default:
          return "&data=basic&data=formData";
      }
    }

    setViewCount(1);
    // If configTable is falsy, use tableValue
    switch (tableValue) {
      case 1:
        return "&data=basic";
      case 2:
        return "&data=basic&data=screening";
      case 3:
        return "&data=basic&data=profile";
      default:
        return "&data=basic&data=formData";
    }
  };

  //Function to call export data
  const createAllRecordExcel = async () => {
    trackEvent(FE_EVENTS.TCS_EXPORT);
    if (openBulkUpdateModal) {
      const excelData = await Axios.get(
        `${UrlLinks.baseUrl}${UrlLinks.tcsGigUrls.getEmptyResourceIdData}?${filterUrl}`
      )
        .then((response) => {
          if (response) {
            let asignIdResponse = response.data.response;
            return asignIdResponse;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      return excelData;
    } else {
      setAllRecordLoading(true);

      await Axios.get(
        `${UrlLinks.baseUrl}${
          UrlLinks.tcsGigUrls.mainListing
        }?rows=${totalRows}&data=basic&data=screening&data=profile&data=formData&userId=${localStorage.getItem(
          "userID"
        )}${filterUrl}`
      )
        .then((response) => {
          if (response) {
            setAllRecord(makeLeadExportData(response.data.response.content));
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
      return;
    }
  };

  const changeColumns = (configTable, viewCount) => {
    let columns = [...allColumns];
    if (configTable === 1) {
      if (viewCount >= 2) columns.push(...screeningColumns);
      if (viewCount >= 3) columns.push(...profileColumns);
      if (viewCount >= 4) columns.push(...formDataColumns);
    } else if (configTable === 2) {
      columns.push(...screeningColumns);
    } else if (configTable === 3) {
      columns.push(...profileColumns);
    } else if (configTable === 4) {
      columns.push(...formDataColumns);
    }
    setColumns(columns);
  };

  //Function to call main listing.
  const getExternalWorkerList = async (
    rows,
    pageNo,
    configTable,
    isViewMore
  ) => {
    // Cancel the previous request if it exists
    if (cancelTokens.current.mainListingData) {
      cancelTokens.current.mainListingData.cancel(
        "Operation canceled due to new request."
      );
    }
    cancelTokens.current.mainListingData = cancelTokenSource;
    setAllRecord([]);
    if (localStorage.getItem("roleType")) {
      setLoader(true);

      const dataType = getDataType(configTable, isViewMore, tableValue);
      let mainUrl = `${UrlLinks.baseUrl}${
        UrlLinks.tcsGigUrls.mainListing
      }?page_no=${pageNo - 1}&rows=${rows}${dataType}${filterUrl}`;

      try {
        const response = await Axios.get(mainUrl, {
          cancelToken: cancelTokenSource.token,
        });
        if (response) {
          const res = response.data.response;
          setTotalRows(res?.totalElements);
          setTotalPages(res?.totalPages);
          if (currentPage > res?.totalPages) {
            setCurrentPage(1);
          }
          setData(res ? res.content : []);
        } else {
          setLoader(false);
        }
      } catch (error) {
        if (Axios.isCancel(error)) {
          console.log("Request canceled:", error.message);
        } else {
          console.error("Error:", error);
          setLoader(false);
        }
      }
    }
  };

  const handlePageChange = (page) => {
    setViewCount(0);
    getExternalWorkerList(perPage, page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    setViewCount(0);
    getExternalWorkerList(newPerPage, 1);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handleActions = async (event, type) => {
    trackEvent(FE_EVENTS.TCS_STATUS_CHANGED, { action: event.target.value });
    // update status validations
    if (event.target.value === "updateData") {
      setOpenBulkUpdateModal(true);
    } else if (event.target.value === "blacklist") {
      setOpenBlacklistMemberModal(true);
    } else if (event.target.value === "backedOut") {
      setOpenBackedOutModal(true);
    }

    // search bar list validations
    else if (event.target.value === "viewMore") {
      let totalCount = viewCount + 1;
      setViewCount(totalCount);
      updateMyData(totalCount, true);
    }

    // rejoin/upload MPA validations
    else if (type === "uploadMPA") {
      setOpenMpaModal(true);
    } else if (event.target.value === "bulkUpdate") {
      setOpenBulkModal(true);
    } else if (
      type === "isActivityStatus" &&
      filters.activityStatus.name === "Backed Out"
    ) {
      await Axios.post(
        `${UrlLinks.baseUrl}${
          UrlLinks.tcsGigUrls.rejoinUsers
        }?assignIds=${selectedAssignIds}&updatedBy=${localStorage.getItem(
          "userID"
        )}`
      )
        .then((res) => {
          if (res.data.response.successfullyRejoined.length) {
            showToast("success", `Successfully rejoined`);
            updateMyData();
          } else {
            showToast("error", `Could not rejoin`);
          }
        })
        .catch((err) => {
          console.log("err", err);
          showToast("error", `Could not rejoin`);
        });
    }
  };

  const handleBlacklist = async (type) => {
    await Axios.post(
      `${UrlLinks.baseUrl}${
        UrlLinks.tcsGigUrls.updateApplicationStatus
      }?assignId=${selectedAssignIds}&status=${
        type === "backedOut" ? 35 : 33
      }&updatedBy=${localStorage.getItem("userID")}`
    )
      .then((res) => {
        if (res.data.code === 1000) {
          showToast(
            "success",
            `Successfully ${
              type === "backedOut" ? "backed out" : "blacklisted"
            }`
          );
          updateMyData();
        }
      })
      .catch((err) => {
        console.log("err", err);
        showToast(
          "error",
          `Could not ${type === "backedOut" ? "back out" : "blacklist"}`
        );
      });
  };

  const makeApplicationStatusList = (data) => {
    let list = [
      {
        id: "-1",
        name: "All",
      },
    ];
    data.map((el) => {
      if (el.typeKey !== "17") {
        list.push({
          id: el.typeKey,
          name:
            el.typeKey === "1"
              ? "Screening passed"
              : el.typeKey === "12"
              ? "Screening failed"
              : el.typeValue,
        });
        return true;
      }
    });
    list.sort((a, b) => {
      return sortStatusOrder.indexOf(a.id) - sortStatusOrder.indexOf(b.id);
    });
    return list;
  };

  const makeJobData = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.jobId,
        name: el.jobTitle,
        status: el.jobStatus,
      });
      return true;
    });
    return list;
  };

  const makeCityList = (data) => {
    let list = [];
    data.map((el, index) => {
      list.push({
        id: index,
        name: el,
        label: el,
      });
      return true;
    });
    return list;
  };

  const makeCenterNameList = (data) => {
    let list = [];
    data.map((el, index) => {
      list.push({
        id: index,
        name: el,
        label: el,
      });
      return true;
    });
    return list;
  };

  const makeQualificationsData = (data) => {
    let list = [];
    data.map((el, index) => {
      list.push({
        id: index,
        name: el,
        label: el,
      });
      return true;
    });
    return list;
  };

  const makeRoleList = (data) => {
    let list = [];
    data.map((el, index) => {
      list.push({
        id: index,
        name: el,
        label: el,
      });
      return true;
    });
    return list;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleAllRowsSelected,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      getDocumentList,
      docListLoader,
      showToast,
      setLoader,
      filters,
      setFilters,
      manualSortBy: true,
    },
    useFilters,
    useSortBy,
    useRowSelect
  );

  const table = (
    <div className={`tableContainer ${styles.tableContainer}`}>
      <table
        {...getTableProps()}
        style={{
          width:
            (tableValue === 1 &&
              (viewCount === 1 ||
                (viewCount === 2 && !screeningLength?.screening?.length))) ||
            (tableValue === 2 && !screeningLength?.screening?.length)
              ? "100%"
              : "max-content",
        }}
      >
        <thead className="thead">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={
                    column.render("Header") === "Name"
                      ? `${
                          !userAction.edit
                            ? "stickWorkerNameV2IsNotEdit"
                            : "stickWorkerNameV2"
                        } zIndex1080 header`
                      : column.render("Header") === "Phone Number"
                      ? `${
                          !userAction.edit
                            ? "stickTcsPhoneNumberIsNotEdit"
                            : "stickTcsPhoneNumber"
                        } zIndex1080 header`
                      : column.render("Header") === "TCS Resource ID"
                      ? `${
                          !userAction.edit
                            ? "stickTcsResourceIdIsNotEdit"
                            : "stickTcsResourceId"
                        } zIndex1080 header`
                      : column.render("Header") === "Status"
                      ? `${
                          !userAction.edit
                            ? "stickTcsStatusIsNotEdit"
                            : "stickTcsStatus"
                        } zIndex1080 header`
                      : column.id.startsWith("screening_")
                      ? "header width300"
                      : column.id === "selection"
                      ? "stickCheckbox3 zIndex1080 header"
                      : column.render("Header") === "Pincode" ||
                        column.render("Header") === "State" ||
                        column.render("Header") === "Aadhaar Number" ||
                        column.render("Header") === "PAN Number" ||
                        column.render("Header") === "DOB" ||
                        column.render("Header") === "Job ID" ||
                        column.render("Header") === "Vertical" ||
                        column.render("Header") === "Job Role" ||
                        column.render("Header") === "Job City" ||
                        column.render("Header") === "Applied on" ||
                        column.render("Header") === "Application Status" ||
                        column.render("Header") === "Remarks" ||
                        column.render("Header") === "Application history" ||
                        column.render("Header") === "Worker history" ||
                        column.render("Header") === "Follow Up 1" ||
                        column.render("Header") === "Follow Up 2" ||
                        column.render("Header") === "Campaign"
                      ? "displayNone"
                      : "header"
                  }
                >
                  <span>{column.render("Header")}</span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={`${
                          cell.column.Header === "Name"
                            ? `${
                                !userAction.edit
                                  ? "stickWorkerNameV2IsNotEdit"
                                  : "stickWorkerNameV2"
                              } zIndex540`
                            : cell.column.Header === "Phone Number"
                            ? `${
                                !userAction.edit
                                  ? "stickTcsPhoneNumberIsNotEdit"
                                  : "stickTcsPhoneNumber"
                              } zIndex540`
                            : cell.column.Header === "TCS Resource ID"
                            ? `${
                                !userAction.edit
                                  ? "stickTcsResourceIdIsNotEdit"
                                  : "stickTcsResourceId"
                              } zIndex540`
                            : cell.column.Header === "Status"
                            ? `${
                                !userAction.edit
                                  ? "stickTcsStatusIsNotEdit"
                                  : "stickTcsStatus"
                              }  zIndex540 zIndex540`
                            : cell.column.id === "selection"
                            ? "stickCheckbox3 zIndex540"
                            : cell.column.Header === "Pincode" ||
                              cell.column.Header === "State" ||
                              cell.column.Header === "Aadhaar Number" ||
                              cell.column.Header === "PAN Number" ||
                              cell.column.Header === "DOB" ||
                              cell.column.Header === "Job ID" ||
                              cell.column.Header === "Vertical" ||
                              cell.column.Header === "Job Role" ||
                              cell.column.Header === "Job City" ||
                              cell.column.Header === "Applied on" ||
                              cell.column.Header === "Application Status" ||
                              cell.column.Header === "Remarks" ||
                              cell.column.Header === "Application history" ||
                              cell.column.Header === "Worker history" ||
                              cell.column.Header === "Follow Up 1" ||
                              cell.column.Header === "Follow Up 2" ||
                              cell.column.Header === "Campaign"
                            ? "displayNone"
                            : "cell"
                        }`}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  /* Useffects */
  useEffect(() => {
    changeColumns(tableValue, viewCount);
    setLoader(false);
  }, [data]);

  useEffect(() => {
    let status = "";
    jobFilterOption === "active"
      ? (status = 1)
      : jobFilterOption === "inactive"
      ? (status = 2)
      : (status = 1);

    Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.jobs.jobsdbListingNew}?paging=0&status=${status}&isTcs=1`
    )
      .then((response) => {
        setJobList(makeJobData(response.data.response));
      })
      .catch((err) => {
        showToast("error", "Could not able to fetch job listing");
      });
  }, [jobFilterOption]);

  useEffect(() => {
    setAllRecordLoading(false);
  }, [allRecord]);

  useEffect(() => {
    if (selectedRowIds) {
      const indexes = Object.values(selectedRowIds);
      let disableButton = true;
      indexes.map((id) => {
        if (id) {
          disableButton = false;
          return true;
        }
        return true;
      });
      setIsRowSelected(disableButton);

      const indexValues = Object.entries(selectedRowIds);
      let assignIdList = [];
      let userIdList = [];
      indexValues.map((id) => {
        if (id[1]) {
          assignIdList.push(data[parseFloat(id[0])].assignId);
          userIdList.push(data[parseFloat(id[0])].userId);
        }
        return true;
      });
      assignIdList = assignIdList.join(",");
      setSelectedAssignIds(assignIdList);
      setSelectedUserIds(userIdList);
    }
  }, [selectedRowIds]);

  useEffect(() => {
    let searchByVar = RemoveExtraSpaces(searchBy);
    let count = searchByVar.split(/[ ,]+/).length;
    if (count > 100) {
      setSearchError(true);
    } else {
      setSearchError(false);
    }
  }, [searchBy]);

  useEffect(() => {
    if (
      filters.activityStatus !== "" ||
      filters.city !== "" ||
      filters.qualification !== "" ||
      filters.role !== "" ||
      filters.tcsCenterName !== ""
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, [filterUrl]);

  useEffect(() => {
    ApplyFilters(filters);
  }, [searchByAuto, selectedOption, selectedStatusOption, jobFilterOption]);

  useEffect(() => {
    getExternalWorkerList(perPage, 1);
    setCurrentPage(1);
  }, [filterUrl, localStorage.getItem("roleType"), toggleStatusUpdated]);

  useEffect(async () => {
    setLoader(true);
    setModalLoader(true);

    // API for Application Status List
    await Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.tcsGigUrls.getApplicationStatus}`
    ).then((response) => {
      setStatusList(
        makeApplicationStatusList(response.data.response.applicationStatus)
      );
    });
    setLoader(false);

    // API for Filter Data List
    await Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.tcsGigUrls.filterMetaData}`
    ).then((response) => {
      setCityList(makeCityList(response.data.response.centerCity));
      setTcsCenterList(makeCenterNameList(response.data.response.centerName));
      setQualificationsList(
        makeQualificationsData(response.data.response.qulification)
      );
      setRoleList(makeRoleList(response.data.response.role));
    });

    setModalLoader(false);
  }, []);

  const loaderBar = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  return (
    <Styles>
      <Grid container className="padding2percent">
        <Grid item xs={12} className="flexDisplay marginBottom8">
          <Grid item xs={6} className="flexDisplay">
            <JobFilter
              uniqueKey="tcsJobsDb"
              jobFilterOption={jobFilterOption}
              setJobFilterOption={setJobFilterOption}
              jobList={jobList}
              disabled={false}
              filters={filters}
              setFilters={setFilters}
              id="jobId"
              statusId="jobStatus"
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              jobFilterOptionList={jobFilterOptionList}
            />
            <JobFilter
              uniqueKey="tcsStatusList"
              jobFilterOption={""}
              setJobFilterOption={null}
              jobList={statusList}
              disabled={filters.activityStatus ? true : false}
              filters={filters}
              setFilters={setFilters}
              id="statusId"
              selectedOption={selectedStatusOption}
              setSelectedOption={setSelectedStatusOption}
              jobFilterOptionList={[]}
            />
          </Grid>
          <Grid item xs={6} className={`${styles.itemRowReverse}`}>
            {!!userAction.edit && (
              <ActionsDropdown
                uniqueKey="actionTcs"
                actions={actions}
                handleActions={handleActions}
                actionList={actionList}
                isRowSelected={isRowSelected}
                dropdownName="Actions"
                searchList={statusList}
                selectedStatusOption={selectedStatusOption}
                selectedOption={selectedOption}
                selectedAssignIds={selectedAssignIds}
                updateMyData={updateMyData}
                toggleStatusUpdated={toggleStatusUpdated}
                setToggleStatusUpdated={setToggleStatusUpdated}
                sortStatusOrder={sortStatusOrder}
              />
            )}
            {!!userAction.export_access && (
              <div className="marginRight15">
                <ExportButton
                  uniqueKey="tcsJobsDb"
                  createAllRecordExcel={createAllRecordExcel}
                  allRecordLoading={allRecordLoading}
                  filename="TCS Gig DB.csv"
                  buttonName="Export to Excel"
                  loadingMessage="Please wait ... it might take few minutes."
                  downloadButton="Download now"
                  isDisabled={data.length === 0}
                />
              </div>
            )}
            {(!filters.activityStatus || filters.activityStatus.id !== 33) && (
              <Button
                variant="outlined"
                className="dataButtonOutline2"
                style={{ marginRight: "20px" }}
                disabled={
                  filters.activityStatus && !selectedAssignIds ? true : false
                }
                onClick={(e) => {
                  handleActions(
                    e,
                    filters.activityStatus ? "isActivityStatus" : "uploadMPA"
                  );
                }}
              >
                {filters.activityStatus ? "Rejoin" : "Upload MPA Lead"}
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} className="flexDisplay">
          <Grid
            item
            xs={6}
            className="flexDisplay padding0 paddingTop8 justifySpaceBetween"
          >
            <SearchBar
              uniqueId="tcsJobsDb"
              searchBy={searchBy}
              setSearchBy={setSearchBy}
              searchError={searchError}
              filters={filters}
              setFilters={setFilters}
              handleSearch={handleSearch}
              handleSearchClose={handleSearchClose}
              ApplyFilters={ApplyFilters}
              placeholder={`Search by Resource ID / Phone Number`}
              buttonName="Search"
              searchInstructions="Use comma or space as delimiter to search multiple values across Resource ID. Max limit 100."
              warningMessage=" Max limit reached. Search 100 pin max."
            />
          </Grid>
          <Grid
            item
            xs={6}
            className={`${styles.itemRowReverse} flexDisplay paddingTop8`}
          >
            <Button
              variant="outlined"
              className={`dataButtonOutline2 ${styles.filterButton}`}
              onClick={() => setOpenFilterDrawer(true)}
            >
              {!isFilter ? (
                <img src={filterIcon} alt="filterIcon" />
              ) : (
                <img src={filterIconMarked} alt="filterIcon" />
              )}
              Filters
            </Button>
            {!!userAction.edit && (
              <div className={"marginRight15"}>
                <CustomStatusDropdown
                  disabled={
                    selectedOption.id === "active" ||
                    selectedOption.id === "inactive"
                  }
                  searchList={searchList}
                  assignIds={selectedAssignIds}
                  dropdownName="Configure Table"
                  buttonName="Update"
                  toggleStatusUpdated={toggleStatusUpdated}
                  setToggleStatusUpdated={setToggleStatusUpdated}
                  uniqueKey="configureTable"
                  updateMyData={updateMyData}
                  fileName="Invalid lead data"
                />
              </div>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} className="flexDisplay paddingTop16">
          <Grid item xs={8}></Grid>
          <Grid item xs={4} className={`${styles.itemRowReverse}`}>
            <button
              className={styles.viewButton}
              style={{ marginLeft: "16px" }}
              disabled={
                tableValue !== 1 ||
                viewCount >= 4 ||
                selectedOption.id === "active" ||
                selectedOption.id === "inactive" ||
                !data.length
              }
              value={"viewMore"}
              onClick={handleActions}
            >
              View more
            </button>
          </Grid>
        </Grid>
        {loader ? (
          loaderBar
        ) : data.length === 0 ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span>No records found</span>
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16">
            {table}
            <Pagination
              rowsperpage={perPage}
              pageNo={currentPage}
              totalElements={totalRows}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
            />
          </Grid>
        )}
        {openBulkUpdateModal && (
          <BulkUpdateModal
            openCasperOnboardingModal={openBulkUpdateModal}
            setOpenCasperOnboardingModal={setOpenBulkUpdateModal}
            statusValues={statusList}
            showToast={showToast}
            updateMyData={updateMyData}
            createAllRecordExcel={createAllRecordExcel}
            title="Bulk Update"
            uniqueKey="tcsBulkUpdate"
            url={`${UrlLinks.baseUrl}${UrlLinks.tcsGigUrls.updateResourceId}${selectedOption.id}`}
            fileName="Invalid lead data"
          />
        )}
        {openMpaModal && (
          <OnboardingModal
            openOnboardingModal={openMpaModal}
            setOpenOnboardingModal={setOpenMpaModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Upload MPA Lead"
            uniqueKey="tcsMpaLead"
            templateButton="Download File Template"
            url={`${UrlLinks.baseUrl}${
              UrlLinks.tcsGigUrls.uploadExcelForTcsMpa
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid MPA data"
          />
        )}
        {openBulkModal && (
          <OnboardingModal
            openOnboardingModal={openBulkModal}
            setOpenOnboardingModal={setOpenBulkModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Bulk Update"
            uniqueKey="tcsGigBulkUpdate"
            templateButton="Download File Template"
            selectedOption={selectedStatusOption}
            url={`${UrlLinks.baseUrl}${
              UrlLinks.workerUrls.uploadTcsMpaWorkers
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid MPA data"
          />
        )}
        {openBlacklistMemberModal && (
          <DeleteConfirmationModal
            uniqueId="blackListMember"
            openConfirmationDialog={openBlacklistMemberModal}
            setOpenConfirmationDialog={setOpenBlacklistMemberModal}
            title={`Blacklist Member`}
            content={
              "Are you sure want to blacklist this member? This action cannot be undone."
            }
            approveButtonText="Confirm"
            declineButtonText="Cancel"
            handleApprove={handleBlacklist}
          />
        )}
        {openBackedOutModal && (
          <DeleteConfirmationModal
            uniqueId="backedOut"
            openConfirmationDialog={openBackedOutModal}
            setOpenConfirmationDialog={setOpenBackedOutModal}
            title={`Backed Out`}
            content={"Are you sure want to Backed out this member?"}
            approveButtonText="Yes"
            declineButtonText="Cancel"
            handleApprove={handleBlacklist}
          />
        )}
        {openFilterDrawer && (
          <Drawer
            anchor="right"
            open={openFilterDrawer}
            onClose={() => {
              setCityId(multipleCity);
              setTcsCenterName(multipleCenterName);
              setQualification(multipleQualification);
              setRole(multipleRole);
              setOpenFilterDrawer(false);
            }}
          >
            <FilterDrawer
              handleClose={() => setOpenFilterDrawer(false)}
              filters={filters}
              setFilters={setFilters}
              applyFilters={ApplyFilters}
              resetFilters={resetFiltersWithoutSearch}
              cityId={cityId}
              setCityId={setCityId}
              tcsCenterName={tcsCenterName}
              setTcsCenterName={setTcsCenterName}
              qualification={qualification}
              setQualification={setQualification}
              role={role}
              setRole={setRole}
              cityList={cityList}
              tcsCenterList={tcsCenterList}
              qualificationsList={qualificationsList}
              roleList={roleList}
            />
          </Drawer>
        )}
      </Grid>
    </Styles>
  );
};

export default ExternalWorker;
